import { Button, Text, Title2, makeStyles } from '@fluentui/react-components';
import { tokens } from '@vigeo/ui';
import { LOGIN_URL } from '@/lib/auth';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
    maxWidth: '32rem',
    marginInline: 'auto',
    paddingBlock: tokens.spacingVerticalXXXL,
    paddingInline: tokens.spacingHorizontalL,
  },
  actions: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
  },
});

/** Shown when nobody is signed in. Staff only — field staff never see this. */
export function SignInPage() {
  const styles = useStyles();

  return (
    <div className={styles.page}>
      <Title2>Sign in</Title2>
      <Text>
        The HR dashboard is for Vigeo office staff. Sign in with your Vigeo account to
        continue.
      </Text>
      <div className={styles.actions}>
        <Button appearance="primary" as="a" href={LOGIN_URL}>
          Sign in with Vigeo
        </Button>
      </div>
    </div>
  );
}
